import { request } from '../request'

/**
 * Hotel 酒店服务页 API 模块
 */
export const hotelApi = {
  /**
   * 获取酒店服务页配置
   * @param {Object} data - { nfcConfig, hotelId, channelType }
   * @returns {Promise} 酒店配置信息
   */
  getHotelServiceConfig(data) {
    return request.post('/hotel/getServiceConfig', data)
  },

  /**
   * 记录服务点击
   * @param {Object} data - { hotelId, serviceId, serviceType, serviceName, channelType }
   */
  recordServiceClick(data) {
    return request.post('/hotel/recordServiceClick', data)
  }
}

export default hotelApi
